import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as CityActions from './city.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CityService } from 'src/app/api/services';

@Injectable()
export class CityEffects {

  constructor(private actions$: Actions, private cityService: CityService) { }

  public loadContractorById$ = createEffect(() => {

    return this.actions$.pipe(
      ofType(CityActions.loadCitysByProvince),
      switchMap(({ provinceId }) =>
        this.cityService.cityGet({ ProvinceId: provinceId, hasHospital: true }).pipe(
          map((city) => CityActions.loadCitysByProvinceSuccess({ data: city })),
          catchError((err) => of(CityActions.loadCitysByProvinceFailure({ error: err })))
        )
      )
    );
  });
}
